import { I17TARIFC16_State } from '@batical/types/src'

const I17TARIFC16: I17TARIFC16_State = {
  bati_version: 1,
  name: '',
  saveDate: 0,
  deleted: 0,
  in_rendElecModule: 34.33,
  in_rendThermiqueModule: 55.88,
  in_partElecConso: 60.0,
  in_tarif: 49.0,
  res_rendementElectReference: 0.0,
  res_rendThermiqueReference: 0.0,
  res_ep: 0.0,
  res_tarif: 0.0,
  mode: 'none',
  calcul_code: 'I17TARIFC16'
}

export default I17TARIFC16
